var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActiveGroups = function SvgActiveGroups(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "active_groups_svg2__a",
    x1: -9.34,
    x2: 146.51,
    y1: 164.55,
    y2: -18.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#active_groups_svg2__a",
    id: "active_groups_svg2__b",
    x1: -46.18,
    x2: 109.68,
    y1: 133.17,
    y2: -49.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#active_groups_svg2__a",
    id: "active_groups_svg2__c",
    x1: 21.63,
    x2: 177.49,
    y1: 190.94,
    y2: 7.97
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#active_groups_svg2__a",
    id: "active_groups_svg2__d",
    x1: 101.23,
    x2: 257.09,
    y1: 258.74,
    y2: 75.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#active_groups_svg2__a",
    id: "active_groups_svg2__e",
    x1: 33.42,
    x2: 189.28,
    y1: 200.98,
    y2: 18.02
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#active_groups_svg2__a",
    id: "active_groups_svg2__f",
    x1: -21.78,
    x2: 134.08,
    y1: 153.95,
    y2: -29.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#active_groups_svg2__a",
    id: "active_groups_svg2__g",
    x1: 67.55,
    x2: 223.41,
    y1: 230.05,
    y2: 47.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#active_groups_svg2__a",
    id: "active_groups_svg2__h",
    x1: 67.32,
    x2: 223.18,
    y1: 229.85,
    y2: 46.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#active_groups_svg2__a",
    id: "active_groups_svg2__i",
    x1: 24.51,
    x2: 180.37,
    y1: 193.39,
    y2: 10.42
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M71.07 39.54a79.68 79.68 0 0 1 57.86 0c1.85.69 3.91-.25 4.6-2.1.67-1.79-.2-3.8-1.96-4.54a86.86 86.86 0 0 0-63.14 0 3.58 3.58 0 0 0-1.91 4.68 3.567 3.567 0 0 0 4.54 1.96Z",
    style: {
      fill: "url(#active_groups_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31 62.09h48.01c3.86 0 7-3.14 7-7v-6.21c0-6.7-4.29-12.66-10.65-14.77l-8.63-2.88c7.41-6.47 8.16-17.73 1.69-25.14S27-2.07 19.59 4.4s-8.16 17.73-1.69 25.14c.52.6 1.09 1.16 1.69 1.69l-8.63 2.88A15.55 15.55 0 0 0 .31 48.88v6.21c0 3.86 3.14 7 7 7M31.32 7.14c5.92.08 10.66 4.94 10.58 10.85-.07 5.81-4.77 10.5-10.58 10.58-5.92-.07-10.66-4.93-10.59-10.85.07-5.82 4.77-10.51 10.59-10.59ZM7.45 48.88a8.43 8.43 0 0 1 5.77-8c6.27-1.74 16.65-7.15 23.2-4.33l13 4.33a8.43 8.43 0 0 1 5.77 8l.14 6.07H7.45z",
    style: {
      fill: "url(#active_groups_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.68 171.47-8.63-2.88c7.41-6.48 8.16-17.73 1.68-25.14s-17.73-8.16-25.14-1.68-8.16 17.73-1.68 25.14c.52.6 1.09 1.16 1.68 1.68l-8.63 2.88A15.57 15.57 0 0 0 .31 186.24v6.21c0 3.87 3.13 7 7 7h48.01c3.87 0 7-3.14 7-7v-6.21c0-6.7-4.29-12.66-10.65-14.77Zm-20.36-26.96c5.92.13 10.61 5.03 10.48 10.95-.13 5.74-4.75 10.36-10.48 10.48-5.92-.13-10.61-5.03-10.48-10.95.13-5.74 4.75-10.36 10.48-10.48m-23.87 47.8v-6.07a8.43 8.43 0 0 1 5.77-8l12.99-4.33c6.52-2.82 16.98 2.59 23.2 4.33a8.43 8.43 0 0 1 5.77 8l.14 6.07z",
    style: {
      fill: "url(#active_groups_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.04 171.47-8.63-2.88c7.41-6.48 8.16-17.73 1.68-25.14s-17.73-8.16-25.14-1.68-8.16 17.73-1.68 25.14c.52.6 1.09 1.16 1.68 1.68l-8.63 2.88a15.57 15.57 0 0 0-10.65 14.77v6.21c0 3.87 3.13 7 7 7h48.01c3.87 0 7-3.14 7-7v-6.21c0-6.7-4.29-12.66-10.65-14.77Zm-20.36-26.96c5.92 0 10.72 4.8 10.72 10.72s-4.8 10.72-10.72 10.72c-5.92-.13-10.61-5.03-10.48-10.95.13-5.74 4.75-10.36 10.48-10.48Zm-23.86 47.8v-6.07a8.43 8.43 0 0 1 5.77-8l12.99-4.33c6.52-2.82 16.98 2.59 23.2 4.33a8.43 8.43 0 0 1 5.77 8l.14 6.07z",
    style: {
      fill: "url(#active_groups_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.04 34.1-8.63-2.88c7.41-6.47 8.16-17.73 1.69-25.14s-17.73-8.16-25.14-1.69-8.16 17.73-1.69 25.14c.52.6 1.09 1.16 1.69 1.69l-8.63 2.88a15.57 15.57 0 0 0-10.65 14.77v6.21c0 3.86 3.14 7 7 7h48.01c3.86 0 7-3.14 7-7v-6.21c0-6.7-4.29-12.66-10.65-14.77M168.68 7.14c5.92.07 10.66 4.92 10.59 10.84a10.72 10.72 0 0 1-10.59 10.59c-5.92-.07-10.66-4.92-10.59-10.84.07-5.82 4.77-10.53 10.59-10.59m-23.86 47.81v-6.07a8.43 8.43 0 0 1 5.77-8l13-4.33c6.51-2.82 16.98 2.6 23.2 4.33a8.42 8.42 0 0 1 5.77 8l.14 6.07h-47.87Z",
    style: {
      fill: "url(#active_groups_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.43 69.68c-1.72-.97-3.9-.36-4.86 1.35a86.92 86.92 0 0 0-9.47 59.3c.38 1.94 2.26 3.2 4.2 2.81s3.2-2.26 2.81-4.2a79.74 79.74 0 0 1 8.68-54.41c.97-1.72.36-3.9-1.35-4.86Z",
    style: {
      fill: "url(#active_groups_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.79 188.56a79.8 79.8 0 0 1-51.58 0c-1.88-.61-3.89.41-4.5 2.29-.59 1.82.36 3.79 2.16 4.46a86.65 86.65 0 0 0 56.27 0c1.85-.68 2.8-2.74 2.11-4.59a3.575 3.575 0 0 0-4.46-2.16",
    style: {
      fill: "url(#active_groups_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.7 133.15c1.93.37 3.81-.88 4.2-2.81 3.99-20.26.64-41.29-9.47-59.3a3.57 3.57 0 0 0-4.89-1.26 3.575 3.575 0 0 0-1.33 4.77 79.8 79.8 0 0 1 8.68 54.41c-.38 1.94.88 3.81 2.81 4.2Z",
    style: {
      fill: "url(#active_groups_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.43 86.42-37.22 32.57L75.22 107c-4.2-4.12-10.94-4.05-15.06.15a10.65 10.65 0 0 0-2.74 4.92c-.85 3.57.22 7.32 2.82 9.91l19.89 19.9c3.86 3.84 10.03 4.04 14.14.47l44.78-39.19c4.61-4.06 5.05-11.08.99-15.69-4.04-4.58-11.02-5.05-15.63-1.05Zm9.93 11.36-44.79 39.19a3.236 3.236 0 0 1-4.39-.15l-19.89-19.89a3.45 3.45 0 0 1 0-4.87 3.45 3.45 0 0 1 4.87 0l14.35 14.35a3.57 3.57 0 0 0 4.88.16l39.74-34.77a3.97 3.97 0 0 1 5.6.51 3.975 3.975 0 0 1-.37 5.48Z",
    style: {
      fill: "url(#active_groups_svg2__i)"
    }
  }));
};
export default SvgActiveGroups;